
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-8 col-md-7 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="addRegistration()">Add New</button>
                <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
            </div>
		    <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="card">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Base URL</th>
								<th>Version</th>
                                <th>Client ID</th>
                                <th>Sync Status</th>
                                <th>Sync Enabled</th>
                                <th>Changed At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of data; let i = index">
                                <td style="width:15%;">{{ row.oneRosterApiUrl }}</td>
								<td style="width:15%;">{{ row.oneRosterApiVersion }}</td>
                                <td style="width:15%;">{{ row.oauthClientId }}</td>
                                <td style="width:10%;">{{ row.syncStatus }}</td>
                                <td style="width:10%;">{{ row.syncEnabled ? 'Yes' : 'No' }}</td>
                                <td style="width:25%;">{{ printDate(row.updatedAt) ? printDate(row.updatedAt) : printDate(row.createdAt) }}</td>
                                <td style="width:25%;">
                                    <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                                    <span title="Sync" class="btn-link" style="cursor: pointer;" (click)="sync(row)">Sync</span> |
                                    <span title="School Mapping" class="btn-link" style="cursor: pointer;" (click)="schoolMapping(row)">School Mapping</span> |
                                    <span title="Remove User" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="removeRegistration(row)"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    